import logo from '../../images/hopdong/logo-tp.png';
import barcode from '../../images/hopdong/barcode.png';
import React from 'react';
import { fetchUserByID } from '../../actions/user'
import { USER_ROLE, DOC_TYPE, PACK_TYPE } from '../../constants';
import s from './Packet.module.scss';
import {Table, Row, Col, Container} from 'reactstrap';
import { Textfit } from 'react-textfit';
import Barcode from 'react-jsbarcode'
import moment from "moment/moment";
import axios from "axios";

class PrintPackages extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasLogo: false,
      billCreator: {},
      logoUrl: logo
    }
  }

  async componentDidMount(){
    this.setState({billCreator: await fetchUserByID(this.props.billData.companyUserID)})
    try {
      const {data: user} = await axios.get(`/user-by-name/${this.props.billData.owner}`)
      console.log(user)
      this.setState({billupCreator: user})
      if (user?.role === 'ops') {
        this.setState({logoUrl: "/kango_logos/" + user.id + "-logo.png"})
      }
    } catch (error) {
      console.log(error)
    }
  }

  formatDate = (str) => {
    return moment(str).format('DD/MM/YYYY')
  }

  getCustomerAddress = (billData) => {
    // Ưu tiên địa chỉ xuất hóa đơn (streetAddress + ward + province)
    if (billData.customer?.streetAddress || billData.customer?.ward || billData.customer?.province) {
      const parts = [billData.customer?.streetAddress, billData.customer?.ward, billData.customer?.province].filter(Boolean)
      if (parts.length > 0) {
        return parts.join(', ')
      }
    }
    // Fallback: địa chỉ Pickup
    return billData.customer?.address || billData.senderAddress || ''
  }

  render() {
    let totalPacks = 0
    if (this.props.billData.packageType === PACK_TYPE) {
      var packs = JSON.parse(this.props.billData.packs)
      totalPacks = packs.reduce(function (a, b) {
        return a + parseInt(b['quantity'])
      }, 0)
    } else {
      totalPacks = this.props.billData.docCount
    }

    let barcodeValue = this.props.billData.referenceCode ? this.props.billData.referenceCode : this.props.billData.kgCode
    let barcodeArr = []
    console.log('this.props.billData ', this.props.billData)
    if (this.props.billData.hawbCode) {
      barcodeValue = this.props.billData.hawbCode
      barcodeValue = barcodeValue ? barcodeValue.replace(/\s/g, "") : '';

      // check barcodeValue has , and split to array
        if (barcodeValue.includes(',')) {
          barcodeArr = barcodeValue.split(',')
        }
    }
    barcodeValue = barcodeValue.replace(/\s/g, "");


    const letterOfGuarantee = () => {
      // Calculate total packages and weight
      let totalPackages = 0;
      let totalWeight = 0;

      if (this.props.billData.packageType === PACK_TYPE) {
        const packs = JSON.parse(this.props.billData.packs);
        totalPackages = packs.reduce((a, b) => a + parseInt(b['quantity'] || 0), 0);
        totalWeight = packs.reduce((a, b) => a + parseFloat(b['chargedWeight'] || 0), 0);
      } else {
        totalPackages = this.props.billData.docCount || 0;
        totalWeight = this.props.billData.docWeight || 0;
      }

      return <div style={{padding:"5%", pageBreakAfter: 'always'}}>
        <Row className="mb-4">
          <Col xs="3" className="d-flex align-items-center">
            <img alt="LOGO" src={this.state.logoUrl} style={{display:"block", "object-fit": "contain", maxHeight: "80px"}} className="img-fluid"/>
          </Col>
          <Col xs="9" className="text-center">
            <h2 style={{color: '#ff9800', fontWeight: 'bold', marginBottom: '5px'}}>CÔNG TY TRÁCH NHIỆM HỮU HẠN</h2>
            <h2 style={{color: '#ff9800', fontWeight: 'bold'}}>TÍN PHÁT EXPRESS</h2>
          </Col>
        </Row>

        <Row className="mb-4 text-center">
          <Col>
            <h3 style={{color: '#ff9800', fontWeight: 'bold'}}>CÔNG VĂN CAM KẾT NỘI DUNG HÀNG XUẤT</h3>
            <h4 style={{color: '#ff9800', fontWeight: 'bold', fontStyle: 'italic'}}>LETTER OF GUARANTEE</h4>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col>
            <p style={{fontSize: '14px', lineHeight: '1.8'}}>
              <span style={{fontStyle: 'italic'}}>Kính gửi/ Dear:</span> <strong>- CHI CỤC HẢI QUAN CHUYỂN PHÁT NHANH (Express Customs Offices).</strong><br/>
              <span style={{marginLeft: '102px', display: 'inline-block'}}><strong>- ĐỘI SÀI CHIẾU AN NINH HÀNG KHÔNG (Airline Security Screening).</strong></span><br/>
              <span style={{marginLeft: '102px', display: 'inline-block'}}><strong>- CÔNG TY SCSC, TCS & TECS (SCSC, TCS & TECS).</strong></span><br/>
              <span style={{marginLeft: '102px', display: 'inline-block'}}><strong>- CÔNG TY TNHH TÍN PHÁT EXPRESS.</strong></span>
            </p>
          </Col>
        </Row>

        <Row className="mb-2">
          <Col>
            <p style={{fontSize: '13px', lineHeight: '2'}}>
              <span style={{fontStyle: 'italic'}}>Tôi/ We are:</span> <strong>{this.props.billData.senderName || this.props.billData.senderCompanyName || ''}</strong>
            </p>
          </Col>
        </Row>

        <Row className="mb-2">
          <Col>
            <p style={{fontSize: '13px', lineHeight: '2'}}>
              <span style={{fontStyle: 'italic'}}>Mã số thuế (Chứng minh nhân dân)/ Tax code or ID:</span> .......................................................................
            </p>
          </Col>
        </Row>

        <Row className="mb-2">
          <Col>
            <p style={{fontSize: '13px', lineHeight: '2'}}>
              <span style={{fontStyle: 'italic'}}>Địa chỉ/ Address:</span> <strong>{this.getCustomerAddress(this.props.billData)}</strong>
            </p>
          </Col>
        </Row>

        <Row className="mb-2">
          <Col>
            <p style={{fontSize: '13px', lineHeight: '2'}}>
              <span style={{fontStyle: 'italic'}}>Chúng tôi có một lô hàng với số vận đơn / We have shipment with AWB no:</span> <strong>{this.props.billData.kgCode || ''}</strong>
            </p>
          </Col>
        </Row>

        <Row className="mb-2">
          <Col>
            <p style={{fontSize: '13px', lineHeight: '2'}}>
              <span style={{fontStyle: 'italic'}}>Số kiện/ Trọng lượng/ Quantity/ Gross weight:</span> <strong>{totalPackages}</strong> pcs; <strong>{totalWeight}</strong> kgs.
            </p>
          </Col>
        </Row>

        <Row className="mb-2">
          <Col>
            <p style={{fontSize: '13px', lineHeight: '2'}}>
              <span style={{fontStyle: 'italic'}}>Tên hàng và chi tiết hàng hóa/ Commodity and description of goods:</span> <strong>{this.props.billData.packContent || ''}</strong>
            </p>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col>
            <p style={{fontSize: '12px', lineHeight: '1.6', textAlign: 'justify'}}>
              <span style={{fontStyle: 'italic'}}>Chúng tôi xin cam kết lô hàng trên của chúng tôi gửi đi là hàng không độc hại, không phải là hàng quốc cấm, không phải là hàng môn, không phải là hàng có chứa pin hay chất cháy nổ, không chứa khí, Gas và không có bất kỳ thành phần nào cấm vận chuyển bằng đường hàng không.hàng hóa cấm xuất nhập khẩu tại cửa khẩu đi và đến. Tất cả thông tin cung cấp trên vận đơn và hóa đơn đính kèm hàng là chính xác. Nếu có bất kỳ vấn đề sự cố nào xảy ra, Chúng tôi xin chịu hoàn toàn mọi trách nhiệm với nội dung khai báo trên.</span>
            </p>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col>
            <p style={{fontSize: '12px', lineHeight: '1.6', textAlign: 'justify', fontStyle: 'italic'}}>
              We commit that the above shipment non-banned from export. It is non-dangerous goods according to IATA Regulations and poses no risk to environment & community and is not included in the non-restriction goods in origin and destination regulated by the local authorities. I declare all the information contained in this letter to be true and correct.
            </p>
          </Col>
        </Row>

        <Row className="mt-5">
          <Col xs="6">
          </Col>
          <Col xs="6" className="text-center">
            <p style={{fontSize: '13px', fontStyle: 'italic', marginBottom: '10px'}}>
              TP. HCM, Ngày {moment(this.props.billData.createdAt).format('DD')} Tháng {moment(this.props.billData.createdAt).format('MM')} Năm {moment(this.props.billData.createdAt).format('YYYY')}
            </p>
            <p style={{fontSize: '13px', lineHeight: '1.5'}}>
              ,.....................................................................
            </p>
            <p style={{fontSize: '13px', lineHeight: '1.5'}}>
              ,.....................................................................
            </p>
            <p style={{fontSize: '13px', fontWeight: 'bold', marginTop: '10px'}}>
              Ký tên, đóng dấu<br/>
              (Ghi rõ họ tên, chức vụ)<br/>
              Name/ Title & Sign
            </p>
            <p style={{fontSize: '11px', marginTop: '20px'}}>
              ....................................................................
            </p>
          </Col>
        </Row>
      </div>
    }

    const shippingMark = (idx, total) => {
      return <div style={{padding:"1.2%", pageBreakAfter: (idx % 2 ===0) ? 'always' : 'none'}}>
      <Row>
        <Col xs="4" className="border d-flex align-items-center justify-content-center">
          <img alt="LOGO" src={this.state.logoUrl} style={{display:"block", "object-fit": "contain", maxHeight: "96px"}} className="img-fluid"/>
        </Col>
        <Col xs="4" className="border text-center">
          {
            barcodeValue ? (
                  <div className="border-bottom">
                    <Row className="flex-row justify-content-center text-center">
                      <Barcode renderer="image" style={{height: '90px', width: '90%'}} options={{displayValue: false}}  value={barcodeArr[idx-1] ? barcodeArr[idx-1]: barcodeValue}/>
                    </Row>
                    <h6 style={{margin: 0}}>HAWB#: {barcodeArr[idx-1] ? barcodeArr[idx-1]: barcodeValue}</h6>
                  </div>

            ) : ''
          }
          <Row className="d-flex justify-content-center text-center">
            <h3 style={{fontSize: '22px'}}><div>AWB#: {this.props.billData.referenceCode}</div> </h3>
          </Row>
        </Col>
        <Col xs="4" className="border text-center d-flex align-items-center justify-content-center">
          <div>
            <h4 className="text-danger"> <strong>Date: {this.formatDate(this.props.billData?.createdAt)}</strong></h4>
            <h4>Service: <strong>{this.props.billData.logisticService}</strong></h4>
          </div>
        </Col>
      </Row>

      <Row>
        <Col className="border text-center">
          <h1 style={{marginBottom: '-10px'}}><strong>{this.props.billData.kgCode}</strong></h1>
        </Col>
      </Row>

      <Row >
        <Col className="border text-center table-info"> <h2><strong>Origin</strong></h2></Col>
        <Col className="border text-center table-info"><h2><strong>Destination</strong></h2></Col>
      </Row>

      <Row>
        <Col className="border text-center"><h2><strong>Vietnam</strong></h2></Col>
        <Col className="border text-center">
          <h2><strong>{this.props.billData.receiverCountry}</strong></h2>
        </Col>
      </Row>

      <Row className='border'>
        <Col>
        <br/>
        <h3>
        <strong>1. From (Shipper)</strong> <br/>
        <strong>Company Name:</strong> {this.props.billData.senderCompanyName} <br/>
        <strong>Contact Name:</strong> &ensp;&nbsp;{this.props.billData.senderName} <br/>
        <strong>Phone/Fax No:</strong> &ensp;&nbsp;{this.props.billData.senderPhone}
        <br/>
        <br/>
        <strong>2. To (Receiver)</strong> <br/>
        <strong>Company Name:</strong> {this.props.billData.receiverCompanyName} <br/>
        <strong>Contact Name:</strong> &ensp;&nbsp;{this.props.billData.receiverName} <br/>
        <strong>Phone/Fax No:</strong> &ensp;&nbsp;{this.props.billData.receiverPhone} <br/>
        <strong>Address: </strong> &ensp;&nbsp;{[this.props.billData.receiverAddr1|| "", this.props.billData.receiverAddr2||null, this.props.billData.receiverAddr3||null, this.props.billData.receiverPostalCode||null].filter(function(el){return el!=null}).join()} <br/>

        </h3>
        </Col>
      </Row>

      <Row>
        <Col className='border text-center'> <h1><strong>{idx}/{total}</strong></h1> </Col>
      </Row>
      <br/>
    </div>
    }

    return (
      <div>
        {[...Array(totalPacks)].map((pkg, i) => shippingMark(i+1, totalPacks) )}
        {letterOfGuarantee()}
      </div>
    );
  }
}

export default PrintPackages;
